"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "svgRef"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Icon = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(Icon, _React$PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          svgRef = _this$props.svgRef,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: (0, _classnames.default)('ui-icon', className),
        ref: svgRef
      }, otherProps), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.533,6 C5.059,6 2.13,12.1 2.1,12.166 L2,12.383 L2.108,12.6 C2.139,12.662 5.308,18.749 11.533,18.749 C17.758,18.749 20.928,12.662 20.959,12.6 L21.066,12.384 L20.966,12.166 C20.937,12.1 18.008,6 11.533,6 Z M11.533,17.75 C6.543,17.75 3.733,13.421 3.121,12.367 C3.693,11.313 6.353,7 11.533,7 C16.713,7 19.374,11.313 19.946,12.367 C19.336,13.421 16.524,17.75 11.533,17.75 Z M11.533,8.632 C10.018464,8.62916757 8.65148352,9.53932224 8.06993203,10.9377589 C7.48838053,12.3361956 7.80688558,13.9472734 8.87682329,15.0192158 C9.946761,16.0911582 11.5572398,16.4126785 12.9567626,15.8337457 C14.3562854,15.254813 15.2689974,13.8895386 15.269,12.375 C15.2684534,10.3107564 13.5972389,8.6364107 11.533,8.632 Z M11.533,15.118 C10.4229274,15.1208329 9.42058376,14.4543215 8.99381303,13.4295601 C8.5670423,12.4047987 8.79999075,11.2238392 9.58392965,10.4378946 C10.3678685,9.65195006 11.548229,9.41598477 12.5740775,9.84013563 C13.599926,10.2642865 14.2689964,11.2649238 14.269,12.375 C14.2695552,13.8874151 13.0454115,15.1146907 11.533,15.118 Z"
      }));
    }
  }]);
  return Icon;
}(_react.default.PureComponent);

Icon.displayName = 'EyeIcon';
var _default = Icon;
exports.default = _default;
//# sourceMappingURL=Eye.js.map